import { Button } from 'react-bootstrap';
import { pushDataLayer } from '../gtm';
import termina from '../assets/cerra.png'; 
import postulate from '../assets/postulateaca.png'; 
import becas from '../assets/becas.png'; 
import materias from '../assets/materias.png'; 
import semanas from '../assets/semanas.png'; 



export default function Step1({ next, onVerRequisitos }) {
  return (
    <div className="intro">
      <img id="termina" src={termina} alt="Termina el liceo" />
      
      <div id="imagenesabajo">
        <img id="becas" src={becas} alt="Becas" />
        <img id="materias" src={materias} alt="Materias" />
        <img id="semanas" src={semanas} alt="Semanas" />
      </div>

      <div className="intro-buttons">
        <Button id="postula" onClick={() => { pushDataLayer('paso2_postulate'); next(); }}>
          <img src={postulate} alt="Postulate" />
        </Button>
        <button className="btn-ver-requisitos" onClick={onVerRequisitos}>
          VER REQUISITOS
        </button>
      </div>

    </div>
  );
}
